export const init = () => {
  if (document.querySelector('.main-content-wrapper')) {
    //links logic start
    const wrapper = document.querySelector('.main-content-wrapper');
    const links = wrapper.querySelectorAll('a[href*="http"]');
    links.forEach((item) => {
      if (window.location.hostname != item.hostname) {
        const elem = document.createElement('span');
        elem.classList.add('external-link');
        item.appendChild(elem);
      }
    });
    //links logic end
    //headings logic start
    if (document.querySelector('.b-heading-box')) {
      const headingBoxWrap = document.querySelector('.b-heading-box');
      const headingBox = document.querySelector('.b-heading-box .list');
      const headings = wrapper.querySelectorAll('h2, h3');
      if (!headings.length) {
        headingBoxWrap.remove();
      }
      else {
        headings.forEach((item, index) => {
          if (item.parentElement == wrapper) {
            const headingID = `h-${index}`;
            item.setAttribute('id', headingID)
            const elem = document.createElement('li');
            elem.innerHTML = `<a href="#${headingID}">${item.innerHTML}</a>`;
            if (item.tagName === 'H2') {
              elem.classList.add('list__item','list__item--main');
            }
            else {
              elem.classList.add('list__item');
            }
            headingBox.appendChild(elem);
            elem.addEventListener('click', () => {
              headingBox.querySelectorAll('.list__item').forEach((item) => {
                item.classList.remove('active');
              })
              elem.classList.add('active');
            });
          }
        });
        headingBoxWrap.style.display = 'block';
        if (document.querySelector('.b-heading-box .g-accordion.active')) {
          const accordion = document.querySelector('.b-heading-box .g-accordion__content');
          accordion.style.maxHeight = `${accordion.scrollHeight}px`;
        }
      }
    }
    //headings logic end
  }
  if (document.querySelector('.aside-components-wrapper')) {
    const sidebar = document.querySelector('.aside-components-wrapper');
    let sidebarPosition = sidebar.getBoundingClientRect().top;
    sidebar.style.maxHeight = `calc(100vh - ${sidebarPosition}px)`;
    window.addEventListener('scroll', () => {
      sidebarPosition = sidebar.getBoundingClientRect().top;
      sidebar.style.maxHeight = `calc(100vh - ${sidebarPosition}px)`;
    });
  }
}